import React from 'react';
import { DeckKey } from '../types/tarot';

interface DeckToggleProps {
  value: DeckKey;
  onChange: (deck: DeckKey) => void;
  disabled?: boolean;
}

const WIDTH = 57;
const HEIGHT = 27;
const PADDING = 3;
const KNOB_SIZE = HEIGHT - PADDING * 2;

const knobOffset = (isCrypto: boolean) => (isCrypto ? PADDING : WIDTH - KNOB_SIZE - PADDING);

export const DeckToggle: React.FC<DeckToggleProps> = ({ value, onChange, disabled = false }) => {
  const isCrypto = value === 'crypto';

  const handleClick = (deck: DeckKey) => {
    if (disabled || deck === value) return;
    onChange(deck);
  };

  return (
    <div
      className={`relative rounded-full border border-white/25 bg-black/30 transition-opacity ${
        disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
      }`}
      style={{ width: WIDTH, height: HEIGHT }}
      role="group"
      aria-label="Select deck"
    >
      <span className="sr-only">Toggle deck</span>

      <div
        className="pointer-events-none absolute top-[3px] rounded-full bg-white text-slate-900 flex items-center justify-center text-xs font-semibold uppercase tracking-[0.3em] shadow-[0_3px_6px_rgba(7,6,22,0.3)] transition-transform duration-200 ease-out"
        style={{
          width: KNOB_SIZE,
          height: KNOB_SIZE,
          transform: `translateX(${knobOffset(isCrypto)}px)`,
        }}
      >
        {isCrypto ? 'C' : 'S'}
      </div>

      <button
        type="button"
        onClick={() => handleClick(isCrypto ? 'standard' : 'crypto')}
        disabled={disabled}
        aria-pressed={isCrypto}
        className="absolute inset-0"
        aria-label={isCrypto ? 'Switch to standard deck' : 'Switch to crypto deck'}
      />
    </div>
  );
};
